import React, { useMemo } from "react";

import { useIntl } from "react-intl";

import { EntitiesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";

import SelectField from "@app/component/input/SelectField";
import getRecipientDisplayName from "@app/util/email/getRecipientDisplayName";

import styles from "./EmailRecipientSelector.module.scss";

interface EmailRecipientSelectorProps {
  disabled?: boolean;
  onSelectRecipientId?: (id?: EntitiesSupportedByEmailFeature["id"]) => void;
  recipients: EntitiesSupportedByEmailFeature[];
  selectedRecipientId?: EntitiesSupportedByEmailFeature["id"];
}

const EmailRecipientSelector: React.FC<EmailRecipientSelectorProps> = ({
  disabled,
  onSelectRecipientId,
  recipients,
  selectedRecipientId,
}) => {
  const intl = useIntl();
  const recipientOptions = useMemo(
    () =>
      recipients.map((recipient) => ({
        label: getRecipientDisplayName(recipient),
        value: recipient.id,
      })),
    [recipients]
  );

  return (
    <SelectField<EntitiesSupportedByEmailFeature["id"]>
      className={styles.container}
      disabled={disabled}
      dropdownMatchSelectWidth={false}
      onChange={onSelectRecipientId}
      options={recipientOptions}
      placeholder={intl.formatMessage({
        id: "email.recipientSelector.placeholder",
        defaultMessage: "Select recipient to simulate",
        description: "email creation modal - Select Recipient",
      })}
      value={selectedRecipientId}
    />
  );
};

export default EmailRecipientSelector;
